/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Type d\'organisation
 */
export const typeOrganizationSchema = z.enum(["PRINCIPAL", "ANNEXE"]).describe("Type d'organisation")